/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/style-encapsulation';
import { Button } from '@zapier/design-system';

type Props = {
  onClick: () => void;
};

export const CancelButton = ({ onClick }: Props) => (
  <Button color="grey" onClick={onClick}>
    Cancel
  </Button>
);
